<template>
  <div>
    <v-row class="py-0">
      <v-col cols="12" class="py-0">
        <v-file-input
          v-model="file"
          :label="label"
          accept="image/*"
          prepend-icon="mdi-camera-outline"
          truncate-length="10"
          hide-details
          outlined
        ></v-file-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { uploadImage } from "@/services/editorService";

export default {
  name: "ImageSelector",
  props: {
    value: {
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      file: null
    };
  },
  watch: {
    async file(file) {
      let formData = new FormData();
      formData.append("file", file);

      const { data } = await uploadImage(formData);

      if (data) {
        this.$emit("select-file", {
          src: data
        });
      }
    }
  }
};
</script>
<style lang="scss"></style>
